import { render, staticRenderFns } from "./RutasStore.vue?vue&type=template&id=6d2c831b"
import script from "./RutasStore.vue?vue&type=script&lang=js"
export * from "./RutasStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports